export type BillingsOrderCargoTaxiRecalculateParamsBillingNode = {
  uuid: string;
  nodeUuid: string;
  checkoutEventUuid?: string;
  lat: number;
  lon: number;
  description: string;
  editableCoordinated: boolean;
  checkoutDate?: Date;
  plannedDate?: Date;
  orderUuid?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
};

export enum BillingsOrderCargoTaxiRecalculateParamsBillingContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  DISCOUNT_OPTIMIZATION = "DISCOUNT_OPTIMIZATION",
  DISCOUNT_BEING_LATE = "DISCOUNT_BEING_LATE",
  DISCOUNT_INCOMPATIBLE_CAR = "DISCOUNT_INCOMPATIBLE_CAR",
  DISCOUNT_OTHER = "DISCOUNT_OTHER",
  CONTRACT_CORRECTION_PERCENTAGE = "CONTRACT_CORRECTION_PERCENTAGE",
}

export type BillingsOrderCargoTaxiRecalculateParamsBillingContributionBaseAmount =
  {
    type: BillingsOrderCargoTaxiRecalculateParamsBillingContributionType.BASE_AMOUNT;
    comment?: string;
    distance: number;
    rate: number;
  };

export type BillingsOrderCargoTaxiRecalculateParamsBillingContributionChargeHaltings =
  {
    type: BillingsOrderCargoTaxiRecalculateParamsBillingContributionType.CHARGE_HALTING;
    comment?: string;
    distance: number;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateParamsBillingContributionContractCorrectionPercentage =
  {
    type: BillingsOrderCargoTaxiRecalculateParamsBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE;
    comment?: string;
    percentage: number;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountOptimization =
  {
    type: BillingsOrderCargoTaxiRecalculateParamsBillingContributionType.DISCOUNT_OPTIMIZATION;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountBeingLate =
  {
    type: BillingsOrderCargoTaxiRecalculateParamsBillingContributionType.DISCOUNT_BEING_LATE;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountIncompatibleCar =
  {
    type: BillingsOrderCargoTaxiRecalculateParamsBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountOther =
  {
    type: BillingsOrderCargoTaxiRecalculateParamsBillingContributionType.DISCOUNT_OTHER;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateParamsBillingContribution =
  | BillingsOrderCargoTaxiRecalculateParamsBillingContributionBaseAmount
  | BillingsOrderCargoTaxiRecalculateParamsBillingContributionChargeHaltings
  | BillingsOrderCargoTaxiRecalculateParamsBillingContributionContractCorrectionPercentage
  | BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountOptimization
  | BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountBeingLate
  | BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountIncompatibleCar
  | BillingsOrderCargoTaxiRecalculateParamsBillingContributionDiscountOther;

export type BillingsOrderCargoTaxiRecalculateParamsBody = {
  billingNodes: BillingsOrderCargoTaxiRecalculateParamsBillingNode[];
  billingsContributions: BillingsOrderCargoTaxiRecalculateParamsBillingContribution[];
};

type BillingsOrderCargoTaxiRecalculateParams = {
  orderUuid: string;
  billingNodes: BillingsOrderCargoTaxiRecalculateParamsBillingNode[];
  billingContributions: BillingsOrderCargoTaxiRecalculateParamsBillingContribution[];
};

export default BillingsOrderCargoTaxiRecalculateParams;
